var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.43683C2.5 5.10809 2.77226 4.8416 3.10811 4.8416H7.09823C7.10364 4.14057 7.17962 3.17953 7.87531 2.51423C8.4228 1.99065 9.1734 1.66699 9.99999 1.66699C10.8266 1.66699 11.5772 1.99065 12.1247 2.51423C12.8204 3.17953 12.8963 4.14057 12.9018 4.8416H16.8919C17.2277 4.8416 17.5 5.10809 17.5 5.43683C17.5 5.76557 17.2277 6.03207 16.8919 6.03207H3.10811C2.77226 6.03207 2.5 5.76557 2.5 5.43683Z",
    fill: "#5F6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67213 18.3337H10.3279C12.5842 18.3337 13.7123 18.3337 14.4458 17.6143C15.1793 16.895 15.2543 15.715 15.4044 13.3551L15.6206 9.95466C15.7021 8.6742 15.7428 8.03396 15.3748 7.62826C15.0069 7.22255 14.3855 7.22255 13.1427 7.22255H6.85737C5.61458 7.22255 4.99319 7.22255 4.62522 7.62826C4.25725 8.03396 4.29797 8.6742 4.3794 9.95466L4.59566 13.3551C4.74574 15.715 4.82078 16.895 5.55427 17.6143C6.28776 18.3337 7.41589 18.3337 9.67213 18.3337Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5aa89a87b711d202b181fcb93f99265d.svg";
export { ForwardRef as ReactComponent };